import { render, staticRenderFns } from "./src/components/subject-list-header.html?vue&type=template&id=0274030b&scoped=true&"
import script from "./src/components/subject-list-header.js?vue&type=script&lang=js&"
export * from "./src/components/subject-list-header.js?vue&type=script&lang=js&"
import style0 from "./src/components/subject-list-header.scss?vue&type=style&index=0&id=0274030b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0274030b",
  null
  
)

export default component.exports